import React from "react";
import "./Title.css";
const Title: React.FC<{
  title?: string;
  title2?: string;
  subTitle1?: string;
  subTitle2?: string;
  titleStyle?: {};
  title2Style?: {};
  subTitleStyle?: {};
  titleContainerStyle?: {};
  subTitle1JSX?: JSX.Element
}> = ({
  title,
  title2,
  title2Style,
  subTitle1,
  subTitle2,
  titleStyle = {},
  subTitleStyle = {},
  titleContainerStyle = {},
  subTitle1JSX
}) => {
    return (
      <div className="bik-sm-title-container" style={titleContainerStyle}>
        {title && <h1 style={titleStyle}>{title}</h1>}
        {title2 && <h1 style={title2Style}>{title2}</h1>}
        {subTitle1 && (
          <p style={subTitleStyle}>
            {subTitle1}
            <sup>*</sup>
          </p>
        )}
        {subTitle1JSX ? subTitle1JSX : <></>}
        {subTitle2 && <p>{subTitle2}</p>}
      </div>
    );
  };
export default Title;
